<app-italo-ecu-logo></app-italo-ecu-logo>

<div id="galery">
    <h1>Galerie</h1>
</div>

<app-language-switcher></app-language-switcher>
<app-navigation></app-navigation>
